import AuthorImage from 'assets/resources/author.webp';

interface IAuthor {
  author: string;
  authorImage: string;
  linkedInAuthorLink: string;
}

type TAuthorsNames = 'Michael Haralson';

export const AUTHORS: Record<TAuthorsNames, IAuthor> = {
  'Michael Haralson': {
    author: 'Michael Haralson',
    authorImage: AuthorImage,
    linkedInAuthorLink: 'https://www.linkedin.com/in/michael-haralson-3b57583',
  },
};
